import React, { useRef } from 'react';
import styled from 'styled-components';
import { Camera, X } from 'lucide-react';
import colors from 'theme/colors';

const MAX_SIZE = 10 * 1024 * 1024;
const ACCEPTED = ['image/jpeg', 'image/png', 'image/webp'];

/**
 * Foto do palestrante: um círculo que abre o seletor de arquivo. A imagem
 * escolhida só sobe quando a sessão é salva, então aqui só se mostra a prévia.
 */
export default function SpeakerPhoto({ url, name, onPick, onRemove, onError }) {
    const input = useRef(null);

    function handleChange(event) {
        const file = event.target.files?.[0];
        event.target.value = '';

        if (!file) {
            return;
        }

        if (!ACCEPTED.includes(file.type)) {
            onError('Use uma imagem JPG, PNG ou WebP.');
            return;
        }

        if (file.size > MAX_SIZE) {
            onError('A foto precisa ter até 10 MB.');
            return;
        }

        onPick(file, URL.createObjectURL(file));
    }

    return (
        <Wrapper>
            <Circle
                type='button'
                aria-label={url ? `Trocar a foto de ${name || 'palestrante'}` : `Adicionar foto de ${name || 'palestrante'}`}
                onClick={() => input.current?.click()}
            >
                {url ? <img src={url} alt='' /> : <Camera size={18} color={colors.night} />}
            </Circle>

            {url && (
                <Remove type='button' aria-label='Remover foto' onClick={onRemove}>
                    <X size={11} strokeWidth={3} color={colors.neutralLight} />
                </Remove>
            )}

            <input
                ref={input}
                type='file'
                accept={ACCEPTED.join(',')}
                hidden
                onChange={handleChange}
            />
        </Wrapper>
    );
}

const Wrapper = styled.div`
    position: relative;
    flex: none;
    width: 48px;
    height: 48px;
`;

const Circle = styled.button`
    width: 48px;
    height: 48px;
    padding: 0;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${colors.neutral};
    border: 1px dashed ${colors.nightLight};

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &:hover { border-color: ${colors.occasionalPurple}; }
    &:focus-visible { outline: 2px solid ${colors.occasionalPurple}; outline-offset: 2px; }
`;

const Remove = styled.button`
    position: absolute;
    top: -4px;
    right: -4px;
    width: 18px;
    height: 18px;
    padding: 0;
    border-radius: 50%;
    border: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${colors.danger};
`;
